// import WaveSurfer from 'wavesurfer.js';
import { APP_BASE_HREF } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { DownloadHelper } from '@app/_core/helper/DownloadHelper';
import { Utils } from '@app/_core/helper/Utils';
import { SecurityService } from '@app/_core/services/security.service';
//import { Utils } from '@app/_core/helper/Utils';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import * as _ from 'underscore';
import videojs from 'video.js';

@Component({
  selector: 'app-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss'],
})
export class AudioComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private videoConfig: any;
  private audioConfig: any;
  private player: any;
  private plugin: any;

  autoPlay: boolean = false;
  mediaSrc = '';
  mediaType = '';
  mediaPlayer: any = null;
  lastSrc = null;
  mediaTitle = '';
  mediaPlayerWait: any;
  playerAttrs = {
    width: '100%',
    height: 'auto',
    alignX: 'center',
    y: 0,
  };
  playerSuffix: any;
  downloadOnly = false;
  popupOnly = false;
  enableFileDownload = false;
  downloadFileName: any;
  playListSelect = null;
  playListCount = null;
  playList: any = null;
  playListIndex = 0;
  playerView = null;
  playerContent: any = '';
  playerWidth = 550;
  playerHeight = 300;
  winName: any;
  popWin: any;
  isVideo: boolean = true;
  initialized = false;
  autoRefreshPopup = false;
  autoInitialize = false;

  wavesurfer: any = null;
  isMuted: boolean = false;

  playButton: any = document.querySelector('#playButton');

  waveform: any = document.querySelector('#waveform');
  volumeIcon: any = document.querySelector('#volumeIcon');
  volumeSlider: any = document.querySelector('#volumeSlider');
  currentTime: any = '00:00:00'; // = document.querySelector("#currentTime")
  totalDuration: any; // = document.querySelector("#totalDuration")

  fullScreenButton = document.querySelector('#fullscreenbutton');
  newTabButton = document.querySelector('#newtabbutton');
  downloadButton = document.querySelector('#downloadbutton');
  isFullScreen: boolean = false;

  popupContent: any = '';
  constructor(
    private webStorageService: WebStorageService,
    elementRef: ElementRef,
    private utils: Utils,
    private securityService: SecurityService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.player = false;
    // this.plugin = WaveSurfer;

    // video.js configuration
    this.videoConfig = {
      controls: true,
      bigPlayButton: false,
      autoplay: true,
      fluid: false,
      loop: false,
      width: 600,
      height: 300,
    };
  }
  @Input()
  playerDetails: any;

  // reference to the element itself: used to access events and methods
  //private _elementRef: ElementRef;

  ngOnInit() {
    /* document.onclick = (event) => {
      alert("document.onclick::"+(event.target as HTMLInputElement).value )
      if((event.target as HTMLInputElement).value =='')
      if (document.fullscreenElement) {
        document
          .exitFullscreen()
          .then(() => {
            this.isFullScreen = !this.isFullScreen;
          })
          .catch((err) => console.error(err));
      } else {
        //this.toggleFullScreen();
      }
    };*/
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['playerDetails'].currentValue != changes['playerDetails'].previousValue) {
      this.mediaPlayerInit();
    }
  }

  ngAfterViewInit() {}
  mediaPlayerInit() {
    this.mediaTitle = this.playerDetails.title;
    this.mediaType = this.playerDetails.type;

    if (Array.isArray(this.playerDetails.list)) {
      this.playList = this.playerDetails.list;
      if (typeof this.playerDetails.src == 'undefined') {
        this.mediaSrc = this.playList[0];
        this.playListIndex = 0;
      } else {
        this.mediaSrc = this.playerDetails.src;
        this.playListIndex = this.utils.getArrayIndex(this.playList, this.mediaSrc, null);
        if (this.playListIndex == -1) {
          this.playListIndex = 0;
          this.playList = [this.mediaSrc].concat(this.playList);
        }
      }
    } else {
      this.mediaSrc = this.playerDetails.src;
      this.playList = [this.mediaSrc];
      this.playListIndex = 0;
    }

    this.isVideo = this.mediaType == 'video';
    this.playerSuffix =
      typeof this.playerDetails.suffix == 'undefined' ? new Date().getTime() : this.playerDetails.suffix;
    this.downloadFileName =
      typeof this.playerDetails.downloadFileName == 'undefined' ? null : this.playerDetails.downloadFileName;
    this.autoInitialize =
      typeof this.playerDetails.autoInitialize == 'undefined'
        ? this.autoInitialize
        : this.autoInitialize || this.playerDetails.autoInitialize;
    this.autoRefreshPopup =
      typeof this.playerDetails.autoRefreshPopup == 'undefined'
        ? this.autoRefreshPopup
        : this.autoRefreshPopup || this.playerDetails.autoRefreshPopup;
    this.popupOnly =
      typeof this.playerDetails.popupOnly == 'undefined'
        ? this.popupOnly
        : this.popupOnly || this.playerDetails.popupOnly;
    this.enableFileDownload =
      typeof this.playerDetails.enableFileDownload == 'undefined'
        ? this.enableFileDownload
        : this.enableFileDownload || this.playerDetails.enableFileDownload;
    //this.downloadOnly = (typeof window.onvidaWrapper == 'object' && (isVideo || onvidaWrapper.version < 1.3));
    this.winName = this.mediaType + this.playerSuffix + 'Win';
    this.playerWidth =
      typeof this.playerDetails.playerWidth == 'number' ? this.playerDetails.playerWidth : this.playerWidth;
    this.playerHeight =
      typeof this.playerDetails.playerHeight == 'number' ? this.playerDetails.playerHeight : this.playerHeight;

    // this.loadPlayer();
    this.initializeMediaPlayer1(this.mediaType, this.mediaSrc, this.autoPlay);

    // this.viewReady();
  }

  initializeMediaPlayer1(playerType: any, src: any, autoPlay: any) {
    window.clearTimeout(this.mediaPlayerWait);

    if (!_.isEmpty(src) && src.indexOf('://') == -1) {
      if (src.indexOf('/') != 0) {
        src = '/' + src;
      }
      src = location.protocol + '//' + location.host + src;
    }

    if (this.mediaPlayer != null) {
      if (this.isVideo) {
        if (src != this.lastSrc) {
          this.mediaPlayer.pause();
          this.mediaPlayer.src(src);
          this.lastSrc = src;
        }
      } else {
        if (src != this.lastSrc) {
          this.mediaPlayer.pause();
          this.mediaPlayer.waveform.load(src);
          this.lastSrc = src;
        }
      }
      if (autoPlay) this.mediaPlayer.play();
    } else {
      this.lastSrc = src;
      if (document.getElementById(playerType + this.playerSuffix) != null) {
        const existingPlayers = videojs.getPlayers();
        if (existingPlayers.hasOwnProperty(playerType + this.playerSuffix))
          videojs(playerType + this.playerSuffix).dispose();

        if (this.isVideo) {
          this.mediaPlayer = videojs(
            playerType + this.playerSuffix,
            {
              controls: true,
              autoplay: autoPlay,
              loop: false,
              width: this.playerWidth,
              height: this.playerHeight,
            },
            () => {
              this.mediaPlayer.src(src);
              this.mediaPlayer.on('pause', this.syncWithPopupVideo);
              this.mediaPlayer.on('seeked', this.syncWithPopupVideo);
              this.mediaPlayer.on('ended', this.syncWithPopupVideo);
              const popupButton = this.mediaPlayer.controlBar.addChild('button');
              const popUpButtonDom = popupButton.el();

              popUpButtonDom.setAttribute('title', 'New Window');
              popUpButtonDom.innerHTML = `<img alt="" style='height:15px;' src='${this.baseHref}/assets/images/icon-external-link-white.png'>\
              <span aria-hidden='true' class='vjs-icon-placeholder'></span>\
              <span class='vjs-control-text' aria-live='polite'>New Window</span>`;

              popUpButtonDom.onclick = () => {
                this.launchPlayerInNewWindow(
                  this.mediaTitle,
                  this.mediaSrc,
                  this.mediaPlayer.currentTime(),
                  this.playerSuffix
                );
              };

              if (this.enableFileDownload) {
                const downloadButton = this.mediaPlayer.controlBar.addChild('button');
                const downloadButtonDom = downloadButton.el();
                downloadButtonDom.setAttribute('title', 'Download ' + (this.isVideo ? 'Video' : 'Audio') + ' File');
                downloadButtonDom.innerHTML = `<img alt="" style='height:15px;' src='${this.baseHref}/assets/images/icon-download-white.png'>\
              <span aria-hidden='true' class='vjs-icon-placeholder'></span>\
              <span class='vjs-control-text' aria-live='polite'>Download</span>`;

                downloadButtonDom.onclick = () => {
                  //alert("clicked")
                  this.downloadFile(
                    this.getDownloadFileName(this.mediaSrc, this.isVideo, this.playListIndex),
                    this.mediaSrc
                  );
                };
                //downloadButtonDom.el().title = 'Download ' + ((this.isVideo) ? 'Video' : 'Audio') + ' File';
                //downloadButtonDom.classList.add('vjs-download');
              }

              if (this.popWin != null && !this.popWin.closed) {
                //if (this.isVideo) {
                this.mediaPlayer.on('ready', () => {
                  if (this.popWin.popPlayer) this.mediaPlayer.currentTime(this.popWin.popPlayer.currentTime());
                });
                // } else {
                /*  this.mediaPlayer.on('waveReady', () => {
                    if (this.popWin.popPlayer)
                      this.mediaPlayer.waveform.surfer.seekTo(this.popWin.popPlayer.waveform.surfer.getCurrentTime() / this.popWin.popPlayer.waveform.surfer.getDuration());
                  });*/
                // }
              }
            }
          );

          this.mediaPlayer.on('waveReady', () => {
            this.mediaPlayer.waveform.surfer.on('pause', this.syncWithPopupAudio);
            this.mediaPlayer.waveform.surfer.on('seek', this.syncWithPopupAudio);
            this.mediaPlayer.waveform.surfer.on('finish', this.syncWithPopupAudio);
          });
        } else {
          //audio player

          // Javascript Event listeners
          window.addEventListener('load', this.setVolumeFromLocalStorage);
          // this.wavesurfer = WaveSurfer.create({
          //   container: '#' + this.mediaType + this.playerSuffix,

          //   /** Stretch the waveform to the full height */
          //   normalize: false,
          //   /** The color of the waveform */
          //   waveColor: '#2997be',
          //   /** The color of the progress mask */
          //   progressColor: '#000048',
          //   /** The color of the playpack cursor */
          //   cursorColor: '#3c3c3d',
          //   /** The cursor width */
          //   cursorWidth: 2,
          //   /** Render the waveform with bars like this: ▁ ▂ ▇ ▃ ▅ ▂ */
          //   barWidth: NaN,
          //   /** Spacing between bars in pixels */
          //   barGap: NaN,
          //   /** Rounded borders for bars */
          //   barRadius: NaN,
          //   /** A vertical scaling factor for the waveform */
          //   barHeight: NaN,
          //   height: 'auto',
          //   /** Minimum pixels per second of audio (i.e. zoom level) */
          //   minPxPerSec: 1,
          //   /** Stretch the waveform to fill the container, true by default */
          //   fillParent: true,
          //   mediaControls: false,
          //   /** Play the audio on load */
          //   autoplay: false,
          //   /** Pass false to disable clicks on the waveform */
          //   interact: true,
          //   /** Hide the scrollbar */
          //   hideScrollbar: false,
          //   /** Audio rate */
          //   audioRate: 1,
          //   autoScroll: true,
          //   autoCenter: true,
          //   //waveColor: 'rgb(200, 0, 200)',
          //   //progressColor: 'rgb(100, 0, 100)',
          //   url: this.mediaSrc//data.URL,
          // })
          this.wavesurfer.once('interaction', () => {
            const playButtonIcon: any = document.querySelector('#playButtonIcon');
            playButtonIcon.src = `${this.baseHref}/assets/images/icon-audio-pause.png`;
            this.wavesurfer.play();
          });

          // Wavesurfer event listeners
          this.wavesurfer.on('ready', () => {
            // Set wavesurfer volume
            //this.wavesurfer.setVolume(volumeSlider.value / 100)
            // Set audio track total duration
            const duration = this.wavesurfer.getDuration();
            this.totalDuration = this.formatTimecode(duration);
          });
          // Sets the timecode current timestamp as audio plays
          this.wavesurfer.on('audioprocess', () => {
            const time = this.wavesurfer.getCurrentTime();
            this.currentTime = this.formatTimecode(time);
          });
          // Resets the play button icon after audio ends
          /*this.wavesurfer.on("finish", () => {
            playButtonIcon.src = "assets/icons/play.svg"
          })*/
        }
      } else {
        this.mediaPlayerWait = window.setTimeout(() => {
          this.initializeMediaPlayer1(playerType, src, autoPlay);
        }, 100);
      }
    }
  }

  /**
   * Retrieves the volume value from local storage and sets the volume slider
   */
  setVolumeFromLocalStorage = () => {
    // Retrieves the volume from local storage, or falls back to default value of 50
    const volume = this.webStorageService.getItemFromLocalStorage('audio-player-volume') * 100 || 50;
    this.volumeSlider.value = volume;
  };
  syncWithPopupVideo(e: any) {
    if (document.hasFocus()) {
      const videoPlayer = videojs('video' + this.playerSuffix);
      //this.popWin = Utils.getPopupWindow('video' + this.playerSuffix + 'Win');
      if (this.popWin != null && !this.popWin.closed) {
        const mediaPlayers = this.popWin.videojs.getPlayers();
        if (mediaPlayers.hasOwnProperty('popPlayer')) {
          mediaPlayers.popPlayer.currentTime(videoPlayer.currentTime());
        }
      }
    }
  }

  togglePlay() {
    const playButtonIcon: any = document.querySelector('#playButtonIcon');
    const isPlaying = this.wavesurfer.isPlaying();
    if (isPlaying) {
      playButtonIcon.src = `${this.baseHref}/assets/images/icon-audio-play.png`;
      this.wavesurfer.pause();
    } else {
      playButtonIcon.src = `${this.baseHref}/assets/images/icon-audio-pause.png`;
      this.wavesurfer.play();
    }
  }

  toggleMute = () => {
    this.wavesurfer.media.muted = !this.wavesurfer.media.muted;
    this.isMuted = this.wavesurfer.media.muted;
    /*if (isMuted) {
      this.volumeIcon.src = `${this.baseHref}/assets/images/icon-audio-mute.png`
      this.volumeSlider.disabled = true
    } else {
      this.volumeSlider.disabled = false
      this.volumeIcon.src = `${this.baseHref}/assets/images/icon-audio-play.png`
    }*/
  };

  handleVolumeChange = (e: any) => {
    // Set volume as input value divided by 100
    // NB: Wavesurfer only excepts volume value between 0 - 1
    const volume = e.target.value / 100;
    this.wavesurfer.setVolume(volume);
    // Save the value to local storage so it persists between page reloads
    localStorage.setItem('audio-player-volume', volume.toString());
  };
  toggleFullScreen() {
    const customPlayer: any = document.getElementById('audioplayer');

    //alert("toggleFullScreen"+this.isFullScreen)
    //this.fullscreenmode();
    if (!this.isFullScreen) {
      if (customPlayer.requestFullscreen) {
        customPlayer.requestFullscreen();
      } else if (customPlayer.webkitRequestFullscreen) {
        /* Safari */
        customPlayer.webkitRequestFullscreen();
      } else if (customPlayer.msRequestFullscreen) {
        /* IE11 */
        customPlayer.msRequestFullscreen();
      }
    } else {
      if (customPlayer.exitFullscreen) {
        customPlayer.exitFullscreen();
      } else if (customPlayer.webkitExitFullscreen) {
        /* Safari */
        customPlayer.webkitExitFullscreen();
      } else if (customPlayer.msExitFullscreen) {
        /* IE11 */
        customPlayer.msExitFullscreen();
      }
    }
    this.isFullScreen = !this.isFullScreen;
  }
  /*@HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    alert("event");
}*/
  /*
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  fullscreenmode() {
alert("fullscreenmode"+this.isFullScreen)

if(!this.isFullScreen){
  this.isFullScreen = !this.isFullScreen;
    let elem: any = document.getElementById('audioplayer');
    if (elem.requestFullscreen) {
      
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { 
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { 
      elem.msRequestFullscreen();
    }
  }
    

  }*/
  openNewTab() {
    this.launchPlayerInNewWindow(this.mediaTitle, this.mediaSrc, this.wavesurfer.getCurrentTime(), this.playerSuffix);
  }

  download() {}

  launchPlayerInNewWindow(title: any, src: any, currentTime: any, parentPlayerSuffix: any) {
    // window[instanceUID + parentPlayerSuffix] = cls.walkieTalkie;
    const videoContent =
      '<video id="popPlayer" class="video-js vjs-default-skin vjs-big-play-centered vjs-fill"></video>';
    const audioContent =
      '<div id="popPlayer" class="video-js vjs-default-skin vjs-fill"></div>\
    <div class="audio-controller">\
        <span class="audio-ctrl play">\
            <button id="playButton" class="play-button" (click)="togglePlay()">\
                <img alt="" id="playButtonIcon" class="play-button-icon" src="' +
      this.baseHref +
      '/assets/images/icon-audio-play.png" alt="Play Button">\
            </button>\
        </span>\
        <span class="audio-ctrl volume">\
            <button id="volumeButton" class="volume-button" (click)="toggleMute()">\
            </button><input [disabled]="isMuted" id="volumeSlider" class="volume-slider" type="range"\
                name="volume-slider" min="0" max="100" value="50" (change)="handleVolumeChange($event)" />\
        </span>\
        <span class="audio-ctrl timeline"><span id="currentTime">\
                {{currentTime}}\
            </span>/\
            <span id="totalDuration">\
                {{totalDuration}}\
            </span>\
        </span>\
        <span class="audio-ctrl full-screen">\
            <button id="fullScreenButton" class="full-screen-button" (click)="toggleFullScreen()">\
                <img alt="" src="' +
      this.baseHref +
      '/assets/images/icon-audio-full-screen.png" id="fullscreenbutton">\
            </button>\
        </span>\
        <span class="audio-ctrl new-tab">\
            <button id="newTabButton" class="new-tab-button" (click)="openNewTab()">\
                <img alt="" src="' +
      this.baseHref +
      '/assets/images/icon-audio-new-tab.png" id="newtabbutton">\
            </button>\
        </span>\
        <span class="audio-ctrl download">\
            <button id="downloadButton" class="download-button" (click)="download()">\
                <img alt="" src="' +
      this.baseHref +
      '/assets/images/icon-audio-download.png" id="downloadbutton">\
            </button>\
        </span>\
    </div>';

    const cssContent =
      '<link href="./assets/public/css/video-js/video-js.css" rel="stylesheet" media="screen"><link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto:400,700%7CMaterial+Icons:400,700">';
    let scriptsContent =
      '<script type="text/javascript" src="./assets/public/js/jquery/jquery.min.js" type="text/javascript"></script>';
    scriptsContent +=
      '<script type="text/javascript" src="./assets/public/js/video.js/video.min.js" type="text/javascript"></script>';
    scriptsContent +=
      '<script type="text/javascript" src="./assets/public/js/wavesurfer.js/wavesurfer.min.js" type="text/javascript"></script>';
    //scriptsContent += '<script type="text/javascript" src="./node_modules/wavesurfer.videojs.js"></script>';
    if (this.isVideo) {
      scriptsContent +=
        '<script type="text/javascript">$(document).ready(function(){\
        var isVideo = ' +
        this.isVideo +
        ';\
        var src = "' +
        src +
        '";\
    window.popPlayer = videojs("popPlayer",\
        {\
            controls: true,\
            autoplay: false,\
            loop: false,\
            width: ' +
        this.playerWidth +
        ',\
            height: ' +
        this.playerHeight +
        ',\
        }, function () {\
                popPlayer.src(src);\
                popPlayer.currentTime(' +
        currentTime +
        ');\
                popPlayer.on("pause", syncWithParentVideo);\
                popPlayer.on("seeked", syncWithParentVideo);\
                popPlayer.on("ended", syncWithParentVideo);';
      if (!this.enableFileDownload) {
        scriptsContent +=
          '\
              var downloadButton = this.mediaPlayer.controlBar.addChild("button");\
              var downloadButtonDom = downloadButton.el();\
              downloadButtonDom.innerHTML = "Hello";\
              downloadButtonDom.onclick = function () {\
                this.downloadFile(this.getDownloadFileName(this.mediaSrc, this.isVideo, this.playListIndex), this.mediaSrc);\
                            }\
              downloadButtonDom.el().title = "Download " + ((this.isVideo) ? "Video" : "Audio") + " File";\
              downloadButtonDom.classList.add("vjs-download");';
      }

      scriptsContent +=
        '\
            $(window).on("unload", function(){\
                notifyOpener();\
            if (isVideo)\
                syncWithParentVideo();\
            else\
                syncWithParentAudio();\
        });\
        });\
        popPlayer.on("waveReady", function(){\
            popPlayer.waveform.surfer.drawer.container.style.height = "100%";\
            $(window).resize(function () {\
            popPlayer.waveform.surfer.empty();\
            popPlayer.waveform.surfer.params.height = popPlayer.waveform.surfer.drawer.container.clientHeight - 30;\
            popPlayer.waveform.surfer.drawer.setHeight(popPlayer.waveform.surfer.drawer.container.clientHeight - 30);\
            popPlayer.waveform.surfer.drawBuffer();\
                popPlayer.waveform.surfer.seekTo(popPlayer.waveform.surfer.getCurrentTime() / popPlayer.waveform.surfer.getDuration());\
        });\
        $(window).resize();\
            popPlayer.waveform.surfer.on("pause", syncWithParentAudio);\
            popPlayer.waveform.surfer.on("seek", syncWithParentAudio);\
            popPlayer.waveform.surfer.on("finish", syncWithParentAudio);\
            popPlayer.waveform.surfer.seekTo(popPlayer.seekTime / popPlayer.waveform.surfer.getDuration());\
        });\
    });\
    var notifyOpener = function(){\
      if (window.opener != null){\
            if (!window.opener.closed){\
                window.opener["' +
        parentPlayerSuffix +
        '"]("close");\
            }\
        }\
  };\
    var syncWithParentAudio = function (e) {\
        if (document.hasFocus()) {\
            if (window.opener != null){\
                if (!window.opener.closed){\
                    var mediaPlayers = window.opener.videojs.getPlayers();\
                    if(mediaPlayers.hasOwnProperty("audio' +
        parentPlayerSuffix +
        '")){\
                        mediaPlayers["audio' +
        parentPlayerSuffix +
        '"].waveform.surfer.seekTo(popPlayer.waveform.surfer.getCurrentTime() / popPlayer.waveform.surfer.getDuration());\
                    }\
                }\
            }\
        }\
    };\
    var syncWithParentVideo = function (e) {\
        if (document.hasFocus()) {\
            if (window.opener != null){\
                if (!window.opener.closed){\
                    var mediaPlayers = window.opener.videojs.getPlayers();\
                    if(mediaPlayers.hasOwnProperty("video' +
        parentPlayerSuffix +
        '")){\
                        mediaPlayers["video' +
        parentPlayerSuffix +
        '"].currentTime(popPlayer.currentTime());\
                    }\
                }\
            }\
        }\
    };\
  var downloadFile = function (fileName, fileURL) {\
      var link = document.createElement("a");\
          link.href = fileURL;\
          link.target = "_blank";\
          link.download = fileName;\
          link.click();\
  };\
    </script>';
    } else {
      scriptsContent +=
        '<script type="text/javascript">$(document).ready(function(){\
    var isVideo = ' +
        this.isVideo +
        ';\
    var src = "' +
        src +
        '";\
    alert("test");\
    popPlayer = WaveSurfer.create({\
      container: "#popPlayer",\
      normalize: false,\
      waveColor: "#2997be",\
      progressColor: "#000048",\
      cursorColor: "#3c3c3d",\
      cursorWidth: 2,\
      barWidth: NaN,\
      barGap: NaN,\
      barRadius: NaN,\
      barHeight: NaN,\
      height: "auto",\
      minPxPerSec: 1,\
      fillParent: true,\
      mediaControls: false,\
      autoplay: false,\
      interact: true,\
      hideScrollbar: false,\
      audioRate: 1,\
      autoScroll: true,\
      autoCenter: true,\
      url: src\
    });\
    popPlayer.wavesurfer.once("interaction", () => {\
      var playButtonIcon = document.querySelector("#playButtonIcon")\
      playButtonIcon.src = "' +
        this.baseHref +
        '/assets/images/icon-audio-pause.png";\
      this.wavesurfer.play()\
    })\
    popPlayer.wavesurfer.on("ready", () => {\
      const duration = this.wavesurfer.getDuration()\
      this.totalDuration = this.formatTimecode(duration)\
    })\
    popPlayer.wavesurfer.on("audioprocess", () => {\
      const time = this.wavesurfer.getCurrentTime()\
      this.currentTime = this.formatTimecode(time)\
    })\
    alert("test1");\
  })\
</script>';

      //audio player

      // this.wavesurfer =
    }

    let headHTML = '<base href="' + location.protocol + '//' + location.host + '/" />';
    headHTML += cssContent;
    headHTML += scriptsContent;

    const bodyHTML = this.isVideo ? videoContent : audioContent;
    //Utils utils = new Utils();
    const playerWin = this.utils.popup({
      url: 'about:blank',
      name: this.winName,
    });

    if (typeof playerWin.popPlayer == 'undefined') {
      playerWin.document.open('text/html', 'replace');
      playerWin.document.write(
        '<html><head>' +
          headHTML +
          '<title>' +
          title +
          '</title></head><body style="margin:0;padding:0;background:#000;">' +
          bodyHTML +
          '</body></html>'
      );
      playerWin.document.close();
    } else {
      if (this.isVideo) {
        if (src == playerWin.popPlayer.src()) {
        } else {
          playerWin.popPlayer.src(src);
        }
        playerWin.popPlayer.currentTime(currentTime);
      } else {
        if (src == playerWin.popPlayer.wavesurfer.params.src) {
          playerWin.popPlayer.waveform.surfer.seekTo(currentTime / playerWin.popPlayer.waveform.surfer.getDuration());
        } else {
          playerWin.popPlayer.seekTime = currentTime;
          playerWin.popPlayer.waveform.load(src);
        }
      }
    }

    playerWin.document.title = title;
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = false;
    }
  }

  syncWithPopupAudio(e: any) {
    if (document.hasFocus()) {
      const audioPlayer: any = videojs('audio' + this.playerSuffix);
      // this.popWin = im.Utils.getPopupWindow('audio' + playerSuffix + 'Win');
      if (this.popWin != null && !this.popWin.closed) {
        const mediaPlayers = this.popWin.videojs.getPlayers();
        if (mediaPlayers.hasOwnProperty('popPlayer')) {
          mediaPlayers.popPlayer.waveform.surfer.seekTo(
            audioPlayer.waveform.surfer.getCurrentTime() / audioPlayer.waveform.surfer.getDuration()
          );
        }
      }
    }
  }

  formatTimecode(seconds: number) {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  }

  getDownloadFileName(fileURL: any, isVideo: any, index: any) {
    let fileName = this.downloadFileName == null ? '' : this.downloadFileName;
    if (this.downloadFileName == null) {
      const timeStamp = new Date();
      let timeStampMonth: any = timeStamp.getMonth() + 1;
      timeStampMonth = timeStampMonth < 10 ? '0' + timeStampMonth : timeStampMonth;
      const timeStampDay = timeStamp.getDate() < 10 ? '0' + timeStamp.getDate() : timeStamp.getDate();

      fileName += 'Onvida_' + this.securityService.clientAbbr;
      fileName += '_' + timeStamp.getFullYear() + '-' + timeStampMonth + '-' + timeStampDay;
      fileName += '_' + (isVideo ? 'Video' : 'Audio');
      fileName += '.' + this.utils.getFileExtension(fileURL);
    }
    if (this.playList.length > 1) {
      const extPos = fileName.lastIndexOf('.');
      fileName = fileName.substring(0, extPos) + '_' + (index + 1) + fileName.substring(extPos);
    }

    return fileName;
  }

  downloadFile(fileName: any, fileURL: any) {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      link.href = fileURL;
      link.target = '_blank';
      link.download = fileName;
      link.click();
    } else {
      DownloadHelper.open(fileURL);
    }
  }
}
